import React, {Component} from 'react';
import {graphql, compose} from 'react-apollo';
import productQuery from 'graphql/queries/product.gql';
import Spinner from 'components/spinner';
import SectionTitle from 'components/section-title';
import SectionBanner from 'components/section-banner';
import Banners from 'components/banners';
import ProductGrid from 'components/product-grid';
import ProductCard from 'components/product-card';
import ViewAllProductsLink from 'components/view-all-products-link';
import AddToCart from './add-to-cart';
import styles from './styles.css';
import ReactMarkdown from 'react-markdown';

@compose(graphql(productQuery, {
    name: 'productData',
    options: ({match: {params: {id}}}) => ({variables: {id}}),
}))
export default class ProductDetail extends Component {
    renderStock(product) {
        const {variationType, variations} = product;

        const renderAmount = n => `${n} ${n === 1 ? 'unidad' : 'unidades'}`;

        if (variations.length === 1) {
            return <span>{renderAmount(variations[0].stock)}</span>;
        }

        const stock = variations
            .map(variation => `${variationType} ${variation.name} (${renderAmount(variation.stock)})`)
            .join(', ');

        return <span>{stock}</span>;
    }

    render() {
        if (this.props.productData.loading) return <Spinner />;
        const {product} = this.props.productData;
        return (
            <div className={styles.root}>
                <SectionBanner />
                <div className={styles.container}>
                    <ViewAllProductsLink />
                    <div className={styles.product}>
                        <div className={styles.image}>
                            <ProductCard key={product.id} product={product}/>
                        </div>
                        <div className={styles.info}>
                            <SectionTitle title={product.name} subtitle={product.description} />
                            <div className={styles.itemData}>
                                <div>
                                    {product.features.map(feature => (<span key={feature.name}>{feature.name}</span>))}
                                    {product.variationType && <span>{product.variationType}</span>}
                                    {product.variations.length > 0 && <span>Stock</span>}
                                </div>
                                <div>
                                    {product.features.map(feature => (
                                        <span key={feature.value}>{feature.value}</span>
                                    ))}
                                    {product.variationType && (
                                        <span>{product.variations.map(variation => variation.name).join(', ')}</span>
                                    )}
                                    {product.variations.length > 0 && this.renderStock(product)}
                                </div>
                            </div>
                            <ReactMarkdown className={styles.sizesTable} source={product.sizes} />
                            <AddToCart product={product} />
                            <div className={styles.disclaimer}>
                                <p>Precios expresados en dólares estadounidenses.</p>
                                <p>
                                    Imágenes no contractuales.
                                    Son solo a modo ilustrativo y pueden diferir del producto real.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.relatedProducts}>
                    <SectionTitle title='Productos relacionados' />
                    <ProductGrid products={product.relatedProducts} />
                </div>
                <Banners noCredit />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/product-detail/index.js